<template>
  <div class="container_login">
    <div class=" display_show">
      <div class="admin_user_login_box">
        <div style="border-bottom: #409eff inset 1px">
          <div class="admin_user_login_head padding_20">
            <h1 >MoreFun后台管理系统</h1>
          </div>
        </div>
        <div class="padding_20" >
          <el-form :model="loginForm" status-icon :rules="loginRules" ref="loginForm" label-width="100px" class="demo-ruleForm" >
            <el-form-item label="用户名" prop="account" >
              <el-input type="email" class="input" v-model.trim="loginForm.account" prefix-icon="el-icon-user"  @keyup.enter.native="submitForm('loginForm')" placeholder="用户名" maxlength="24" minlength="6" clearable auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password" >
              <el-input class="input" type="password" show-password maxlength="16" prefix-icon="el-icon-lock"   @keyup.enter.native="submitForm('loginForm')" minlength="6" clearable placeholder="密码" v-model.trim="loginForm.password" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div>
            <el-button type="primary" @click="submitForm('loginForm')" :loading="loading" class="login-btn"><i class="el-icon-upload" style="margin-right: 8px" ></i>登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="../../assets/scss/login.css"></style>
<script>
import {Auth, AutoLogin, Login} from '../../api/login'
export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      block_num: 0,
      loading: false,
      loginRules: {
        account: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.autoLogin()
  },
  methods: {
    submitForm (formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Login({
            account: this.loginForm.account,
            password: this.loginForm.password
          }).then((res) => {
            this.loading = false
            let { status, message } = res
            if (status === 2000) {
              this.$notify({
                message: message,
                type: 'success',
                offset: 100,
                showClose: false
              })
              // 存储用户信息
              let data = res.data
              this.$store.commit('setToken', data.token)
              this.$store.commit('setUserInfo', data.userInfo)
              this.block_num = 0
              setTimeout(() => {
                this.$router.push({name: 'index'})
              }, 500)
            } else {
              this.block_num += 1
              if (this.block_num >= 5) {
                this.ipVerify()
              }
              this.$notify({
                message: message,
                type: 'warning',
                offset: 100,
                showClose: false
              })
            }
          })
        }
      })
      this.loading = false
    },
    ipVerify () {
      Auth().then(res => {
        if (res.status !== 2000) {
          window.location.href = 'about:blank'
        }
      })
    },
    // 自动登录
    autoLogin () {
      let email = this.$route.query.email
      let sign = this.$route.query.sign
      if (email && sign) {
        const loading = this.$loading({
          lock: true,
          text: '正在自动登录中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        AutoLogin({
          email: email,
          sign: sign
        }).then(res => {
          let { status, message } = res
          if (status === 2000) {
            this.$notify({
              message: message,
              type: 'success',
              offset: 100,
              showClose: false
            })
            // 存储用户信息
            let data = res.data
            this.$store.commit('setToken', data.token)
            this.$store.commit('setUserInfo', data.userInfo)
            this.block_num = 0
            setTimeout(() => {
              this.$router.push({name: 'index'})
            }, 500)
          } else {
            this.$notify({
              message: message,
              type: 'warning',
              offset: 100,
              showClose: false
            })
          }
          loading.close()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/index.vue